import React, { useState } from 'react';
import styled from 'styled-components';
import { Formik, Form } from 'formik';
import TextInput from './TextInput';
import { PrimaryButton } from './Button';
import { Body } from './typography';

const StyledForm = styled(Form)`
    display: flex;
    margin-top: 16px;

    > div {
      flex: 1;
    }

    button {
      margin-top: 0;

      height: 60px;

      max-width: 200px;
    }
`

export default function InlineNewsletter() {
    const [submitted, setSubmitted] = useState(false);

    function onSubmit(values) {
        return fetch("/.netlify/functions/newsletter", {
            method: "POST",
            body: JSON.stringify({ email: values.email, oos_spf: true }),
        }).then(() => setSubmitted(true));
    }

    return (
        <Formik onSubmit={onSubmit} initialValues={{ email: "" }}>
            {submitted ? <Body>Thanks! We'll keep you posted!</Body> : <StyledForm>
                <TextInput
                    required
                    label="Enter email for notification"
                    name="email"
                    type="email"
                />
                <PrimaryButton type="submit">Submit</PrimaryButton>
            </StyledForm>}
        </Formik>
    );
}